module.exports = __webpack_public_path__ + "static/media/Zamora-Drywall-Inc (7).241ed2b5.jpg";